<template>
  <v-card elevation="0" rounded="xl" class="mt-2" :loading="loading">
    <div class="d-flex align-center pa-2 pb-0 gap-3">
      <v-btn @click="$refs.calendar.prev()" icon>
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span class="text-center" style="min-width: 100px">
        {{ value | date("MMMM YYYY") }}
      </span>
      <v-btn @click="$refs.calendar.next()" icon>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn @click="$emit('viewType', 'list')" icon :disabled="loading">
        <v-icon>mdi-view-list</v-icon>
      </v-btn>
    </div>
    <div class="px-3 pb-2">
      <v-switch
        class="mt-0"
        v-model="filter.includeChildren"
        label="Exibir sub-eventos"
        hide-details
        dense
      />
    </div>
    <v-calendar
      ref="calendar"
      :event-height="42"
      v-model="value"
      :events="events"
      @click:event="showEvent"
      event-overlap-mode="stack"
      :event-color="getEventColor"
      style="min-height: calc(100vh - 240px)"
    >
      <template #event="{ event }">
        <div class="d-flex gap-2 align-center">
          <div>
            <v-img
              :src="event.cover"
              :height="42"
              :width="(42 * 16) / 9"
              :aspect-ratio="16 / 9"
              class="rounded"
            />
          </div>
          <div>
            <b>{{ event.name }}</b>
            <p class="mb-0 lh-1">
              {{ event.Organization.name }} -
              {{ event.Organization.Platform.name }}
            </p>
          </div>
        </div>
      </template>
    </v-calendar>
    <v-menu
      v-model="selectedOpen"
      :close-on-content-click="false"
      :activator="selectedElement"
      offset-y
      top
      max-width="450px"
      content-class="rounded-xl"
    >
      <v-card min-width="350px" max-width="450px" rounded="xl" class="pa-3">
        <h6>{{ selectedEvent?.name }}</h6>
        <party-onboarding :item="selectedEvent" />
        <div class="d-flex flex-wrap align-end gap-1 mt-3">
          <v-btn
            :to="`//${selectedEvent?.Organization.Platform.domain}/shop/${
              selectedEvent?.Organization.slug
            }/${selectedEvent?.slug || selectedEvent?.id}`"
            target="_blank"
            color="primary"
            text
            small
          >
            Ver Evento <v-icon right small>mdi-open-in-new</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn @click="management(selectedEvent)" color="primary">
            Gerenciar
          </v-btn>
        </div>
      </v-card>
    </v-menu>
    <div class="d-flex align-center pa-2 pt-1 gap-3">
      <v-btn @click="$refs.calendar.prev()" icon>
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span class="text-center" style="min-width: 100px">
        {{ value | date("MMMM YYYY") }}
      </span>
      <v-btn @click="$refs.calendar.next()" icon>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
import PartyStatus from "@/utils/partyStatus";
import { mapGetters } from "vuex";
import PartyOnboarding from "./modules/PartyOnboarding.vue";
// import PartyQuickReport from "./PartyQuickReport.vue";

export default {
  components: { PartyOnboarding },
  data: () => ({
    value: new Date(),
    selectedOpen: false,
    selectedElement: null,
    selectedEvent: null,

    filter: {
      includeChildren: false,
    },
  }),
  methods: {
    getEventColor({ status }) {
      if (status.status === "pending") return "success";
      if (status.status === "inactive") return "error";
      if (status.status === "inProgress") return "warning";

      return "grey";
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    management(party) {
      this.$router.push({
        name: "admin.parties.management",
        params: { id: party.id },
      });
    },
  },
  computed: {
    ...mapGetters("auth", ["hasPermission", "config"]),
    ...mapGetters("organization", ["selectedOrganization"]),
    events() {
      const parties = this.parties || { active: [], inactive: [] };
      const allParties = [...parties.active, ...parties.inactive].filter(
        (party) => {
          if (!this.filter.includeChildren) return !party.ParentParty?.name;
          return true;
        }
      );
      return allParties.map((party) => {
        const status = new PartyStatus(party);
        return {
          ...party,
          start: moment(party.date).toDate(),
          end: moment(party.endDate).toDate(),
          status: status,
        };
      });
    },
  },
  props: {
    parties: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss"></style>
